import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import request from './utils/Request';
import tools from  "./utils/Tools"
import wx from "weixin-js-sdk"
const app = createApp(App);
app.use(router);

app.provide('$request', request);
app.provide('$tools', tools);
app.provide('$wx', wx);
app.mount('#app');
